import React, { useState, useEffect } from "react";
import "./NewUI.css";

/* ===== TON APP EXISTANTE ===== */

import Transactions from "./components/Transactions";
import AddTransaction from "./components/AddTransaction";
import ImportCSV from "./components/ImportCSV";
import Dashboard from "./components/Dashboard";
import ExpensesChart from "./components/ExpensesChart";
import Merchants from "./components/Merchants";
import Budget from "./components/Budget";
import Categories from "./components/Categories";
import CashBalance from "./components/CashBalance";
import BudgetPlanner from "./components/BudgetPlanner";
import TrendsTable from "./components/TrendsTable";
import VacationCockpit from "./components/VacationCockpit";
import { resetData, getBudgetStatus } from "./api";
import api from "./api";

import LoginPage from "./components/LoginPage";
import UserSettings from "./components/UserSettings";
import ExpenseSubcategoryChart from "./components/ExpenseSubcategoryChart";
import SalarySettings from "./components/SalarySettings";
import CategorizationQueue from "./components/CategorizationQueue";
import BankSync from "./components/BankSync";
import ActivityLog from "./components/ActivityLog";
import NotificationSettings from "./components/NotificationSettings";

export default function NewUI() {

  /* ===== AUTH ===== */
  const [currentUser, setCurrentUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem('user')); } catch { return null; }
  });

  useEffect(() => {
    const handleLogout = () => setCurrentUser(null);
    window.addEventListener('auth:logout', handleLogout);
    return () => window.removeEventListener('auth:logout', handleLogout);
  }, []);

  const handleLogin = (user) => setCurrentUser(user);
  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setCurrentUser(null);
  };

  /* ===== ÉTATS ===== */

  const [refreshKey, setRefreshKey] = useState(0);
  const [toReviewCount, setToReviewCount] = useState(0);

  const [selectedMonth, setSelectedMonth] = useState(() => {
    const savedMonth = localStorage.getItem("selectedMonth");
    return savedMonth || new Date().toISOString().slice(0, 7);
  });

  const [activeBudgetPage, setActiveBudgetPage] = useState("budget");
  const [tab, setTab] = useState("dashboard");
  const [showAdd, setShowAdd] = useState(false);

  useEffect(() => {
    localStorage.setItem("selectedMonth", selectedMonth);
  }, [selectedMonth]);

  const handleGlobalUpdate = () => {
    setRefreshKey(prev => prev + 1);
  };

  // Charge le count des transactions à catégoriser
  useEffect(() => {
    if (!currentUser) return;
    api.get('/transactions/to-review')
      .then(r => setToReviewCount(r.data.length))
      .catch(() => {});
  }, [refreshKey, currentUser]);

  const handleMonthChange = (value) => {
    setSelectedMonth(value);
    setRefreshKey(prev => prev + 1);
  };

  // Tous les hooks doivent être déclarés avant ce return conditionnel (règle React).
  if (!currentUser) return <LoginPage onLogin={handleLogin} />;

  return (
    <div className="app">

      <Header
        selectedMonth={selectedMonth}
        onMonthChange={handleMonthChange}
        onAddClick={() => setShowAdd(true)}
        currentUser={currentUser}
        onLogout={handleLogout}
      />

      <Navigation tab={tab} setTab={setTab} toReviewCount={toReviewCount} currentUser={currentUser} />

      {/* ===== PANNEAU AJOUT DÉPENSE ===== */}

      {showAdd && (
        <div className="panel">

          <div className="panel-header">
            <h2>Ajouter une dépense</h2>

            <button onClick={() => setShowAdd(false)}>
              ✕
            </button>
          </div>

          <AddTransaction
            onAdded={() => {
              handleGlobalUpdate();
              setShowAdd(false);
            }}
          />

        </div>
      )}

      <MainContent
        tab={tab}
        selectedMonth={selectedMonth}
        refreshKey={refreshKey}
        onUpdate={handleGlobalUpdate}
        activeBudgetPage={activeBudgetPage}
        setActiveBudgetPage={setActiveBudgetPage}
        currentUser={currentUser}
      />

    </div>
  );
}

/* =====================================================
   HEADER
===================================================== */

function Header({ selectedMonth, onMonthChange, onAddClick, currentUser, onLogout }) {
  const shiftMonth = (delta) => {
    const [y, m] = selectedMonth.split('-').map(Number);
    const d = new Date(y, m - 1 + delta, 1);
    onMonthChange(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`);
  };

  const navBtn = { background: 'none', border: 'none', cursor: 'pointer', fontSize: 18, color: 'var(--text-soft)', padding: '0 4px', lineHeight: 1 };

  return (
    <div className="header">

      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
        <button style={navBtn} onClick={() => shiftMonth(-1)} title="Mois précédent">‹</button>
        <div>
          <div className="month">Mois</div>
          <input
            type="month"
            value={selectedMonth}
            onChange={(e) => onMonthChange(e.target.value)}
          />
        </div>
        <button style={navBtn} onClick={() => shiftMonth(1)} title="Mois suivant">›</button>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        {currentUser && (
          <span style={{ fontSize: 13, color: 'var(--text-soft)' }}>
            {currentUser.firstName}
          </span>
        )}
        <button className="cta" onClick={onAddClick}>+ Dépense</button>
        <button
          onClick={onLogout}
          style={{
            padding: '8px 14px', borderRadius: 8, border: '1px solid var(--border)',
            background: 'var(--surface)', color: 'var(--text-soft)',
            fontSize: 13, cursor: 'pointer',
          }}
        >
          Déconnexion
        </button>
      </div>

    </div>
  );
}

/* =====================================================
   NAVIGATION
===================================================== */

function Navigation({ tab, setTab, toReviewCount, currentUser }) {
  const isAdmin = currentUser?.role === 'admin';

  const tabs = [
    ["dashboard", "Dashboard"],
    ["transactions", "Transactions"],
    ["budget", "Budget"],
    ...(isAdmin ? [["activity", "Journal"]] : []),
    ["settings", "Paramètres"]
  ];

  return (
    <div className="tabs">

      {tabs.map(([id, label]) => (
        <button
          key={id}
          className={tab === id ? "active" : ""}
          onClick={() => setTab(id)}
          style={{ position: 'relative' }}
        >
          {label}
          {id === "transactions" && toReviewCount > 0 && (
            <span style={{
              position: 'absolute', top: 4, right: 4,
              background: '#dc2626', color: '#fff',
              fontSize: 10, fontWeight: 700,
              borderRadius: 10, padding: '1px 5px',
              lineHeight: 1.4,
            }}>
              {toReviewCount}
            </span>
          )}
        </button>
      ))}

    </div>
  );
}

/* =====================================================
   CONTENU
===================================================== */

function MainContent({
  tab,
  selectedMonth,
  refreshKey,
  onUpdate,
  activeBudgetPage,
  setActiveBudgetPage,
  currentUser,
}) {

  if (tab === "dashboard") {
    return (
      <>
        <Dashboard month={selectedMonth} refreshKey={refreshKey} />
        <DashboardCharts month={selectedMonth} refreshKey={refreshKey} />
        <CashBalance />
      </>
    );
  }

  if (tab === "transactions") {
    return <TransactionsContent
      refreshKey={refreshKey}
      onUpdate={onUpdate}
      selectedMonth={selectedMonth}
    />;
  }

  if (tab === "budget") {
    return (
      <>
        <div className="subnav">
          {[["budget", "Suivi Budget"], ["trends", "Tendances"], ["vacation", "Vacances"], ["planner", "Préparer Budget"]].map(([id, label]) => (
            <button
              key={id}
              onClick={() => setActiveBudgetPage(id)}
              style={{
                background: activeBudgetPage === id ? "#1976d2" : "#fff",
                color: activeBudgetPage === id ? "#fff" : "#444",
                fontWeight: activeBudgetPage === id ? 600 : 400,
              }}
            >{label}</button>
          ))}
        </div>

        {activeBudgetPage === "budget" && (
          <Budget
            month={selectedMonth}
            refreshKey={refreshKey}
            onUpdated={onUpdate}
          />
        )}

        {activeBudgetPage === "trends" && (
          <TrendsTable month={selectedMonth} />
        )}

        {activeBudgetPage === "vacation" && (
          <VacationCockpit month={selectedMonth} />
        )}

        {activeBudgetPage === "planner" && (
          <BudgetPlanner
            month={selectedMonth}
            refreshKey={refreshKey}
            onUpdated={onUpdate}
          />
        )}

      </>
    );
  }

  if (tab === "activity") {
    return <ActivityLog refreshKey={refreshKey} />;
  }

  if (tab === "settings") {
    return <SettingsContent refreshKey={refreshKey} onUpdate={onUpdate} currentUser={currentUser} />;
  }

  return null;
}

/* =====================================================
   TRANSACTIONS CONTENT
===================================================== */

function TransactionsContent({ refreshKey, onUpdate, selectedMonth }) {
  const [txPage, setTxPage] = useState('list');

  return (
    <>
      <div className="subnav">
        {[['list', 'Liste'], ['queue', 'À catégoriser']].map(([id, label]) => (
          <button
            key={id}
            onClick={() => setTxPage(id)}
            style={{
              background: txPage === id ? '#1976d2' : '#fff',
              color: txPage === id ? '#fff' : '#444',
              fontWeight: txPage === id ? 600 : 400,
            }}
          >{label}</button>
        ))}
      </div>
      {txPage === 'list' && (
        <Transactions refreshKey={refreshKey} onUpdated={onUpdate} month={selectedMonth} />
      )}
      {txPage === 'queue' && (
        <div style={{ padding: '0 16px 32px' }}>
          <CategorizationQueue onUpdated={onUpdate} />
        </div>
      )}
    </>
  );
}

/* =====================================================
   SETTINGS CONTENT
===================================================== */

function SettingsContent({ refreshKey, onUpdate, currentUser }) {
  const isAdmin = currentUser?.role === 'admin';
  const [settingsTab, setSettingsTab] = useState(isAdmin ? "import" : "categories");

  const tabs = [
    ...(isAdmin ? [
      ["import", "Import & Reset"],
      ["banque", "Banque"],
      ["notifications", "Notifications"],
      ["revenus", "Revenus"],
    ] : []),
    ["categories", "Catégories"],
    ["merchants", "Marchands"],
    ["users", "Utilisateurs"],
  ];

  return (
    <>
      <div className="subnav">
        {tabs.map(([id, label]) => (
          <button
            key={id}
            onClick={() => setSettingsTab(id)}
            style={{
              background: settingsTab === id ? "#1976d2" : "#fff",
              color: settingsTab === id ? "#fff" : "#444",
              fontWeight: settingsTab === id ? 600 : 400,
            }}
          >
            {label}
          </button>
        ))}
      </div>

      {settingsTab === "import" && (
        <>
          <ImportCSV onImported={onUpdate} />
          <ResetSection onReset={onUpdate} />
        </>
      )}

      {settingsTab === "categories" && (
        <Categories onUpdated={onUpdate} />
      )}

      {settingsTab === "merchants" && (
        <Merchants refreshKey={refreshKey} onUpdated={onUpdate} />
      )}

      {settingsTab === "users" && (
        <UserSettings currentUser={currentUser} />
      )}

      {settingsTab === "banque" && (
        <BankSync />
      )}

      {settingsTab === "notifications" && (
        <NotificationSettings />
      )}

      {settingsTab === "revenus" && (
        <SalarySettings currentUser={currentUser} />
      )}
    </>
  );
}

/* =====================================================
   DASHBOARD CHARTS
   Pie catégories + bar sous-catégories (même layout que Budget)
===================================================== */

function DashboardCharts({ month, refreshKey }) {
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [subcategories, setSubcategories] = useState([]);

  useEffect(() => {
    async function load() {
      try {
        const res = await getBudgetStatus(month);
        setSubcategories(res.data?.subcategories || []);
      } catch {}
    }
    load();
    setSelectedCategory(null);
  }, [month, refreshKey]);

  return (
    <div className="charts-row">
      <div>
        <ExpensesChart
          month={month}
          refreshKey={refreshKey}
          onSelectCategory={cat => setSelectedCategory(cat)}
        />
      </div>
      <div>
        {selectedCategory
          ? <ExpenseSubcategoryChart data={subcategories} category={selectedCategory} month={month} />
          : <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 320, color: 'var(--text-muted)', fontSize: 14 }}>
              ← Cliquer une catégorie pour voir le détail
            </div>
        }
      </div>
    </div>
  );
}

/* =====================================================
   RESET SECTION
   Réinitialise transactions + merchants (garde les catégories)
===================================================== */

function ResetSection({ onReset }) {
  const [loadingData, setLoadingData] = useState(false);
  const [loadingBudgets, setLoadingBudgets] = useState(false);

  const handleResetData = async () => {
    if (!window.confirm("⚠️ Réinitialiser toutes les transactions et marchands ?\n\nLes catégories seront conservées.")) return;
    if (!window.confirm("🔴 Dernière confirmation — cette action est IRRÉVERSIBLE.\n\nContinuer ?")) return;
    setLoadingData(true);
    try {
      await resetData();
      onReset?.();
    } catch (err) {
      const msg = err?.response?.data?.error || err?.message || "Erreur inconnue";
      alert(`Erreur :\n${msg}`);
    } finally {
      setLoadingData(false);
    }
  };

  const handleResetBudgets = async () => {
    if (!window.confirm("⚠️ Supprimer tous les budgets de tous les mois ?\n\nLes templates seront conservés.")) return;
    if (!window.confirm("🔴 Dernière confirmation — cette action est IRRÉVERSIBLE.\n\nContinuer ?")) return;
    setLoadingBudgets(true);
    try {
      await api.delete("/budget/months/all");
      onReset?.();
    } catch (err) {
      const msg = err?.response?.data?.error || err?.message || "Erreur inconnue";
      alert(`Erreur :\n${msg}`);
    } finally {
      setLoadingBudgets(false);
    }
  };

  const dangerStyle = {
    padding: '10px 22px',
    color: '#fff',
    border: 'none',
    borderRadius: 6,
    fontWeight: 600,
    fontSize: 14,
    cursor: 'pointer',
  };

  return (
    <div style={{
      margin: '32px 0',
      padding: '20px 24px',
      border: '1px solid #ffcdd2',
      borderRadius: 10,
      background: '#fff8f8',
    }}>
      <h3 style={{ margin: '0 0 16px', color: '#c62828' }}>Zone dangereuse</h3>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>

        <div>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>Réinitialiser les transactions</div>
          <p style={{ margin: '0 0 10px', color: '#555', fontSize: 13 }}>
            Supprime toutes les transactions et marchands. Les catégories sont conservées.
          </p>
          <button
            onClick={handleResetData}
            disabled={loadingData}
            style={{ ...dangerStyle, background: loadingData ? '#ccc' : '#c62828' }}
          >
            {loadingData ? 'Réinitialisation…' : 'Réinitialiser les transactions'}
          </button>
        </div>

        <div style={{ borderTop: '1px solid #ffcdd2', paddingTop: 20 }}>
          <div style={{ fontWeight: 600, marginBottom: 4 }}>Réinitialiser les budgets</div>
          <p style={{ margin: '0 0 10px', color: '#555', fontSize: 13 }}>
            Supprime tous les budgets mensuels. Les templates sont conservés.
          </p>
          <button
            onClick={handleResetBudgets}
            disabled={loadingBudgets}
            style={{ ...dangerStyle, background: loadingBudgets ? '#ccc' : '#c62828' }}
          >
            {loadingBudgets ? 'Suppression…' : 'Réinitialiser tous les budgets'}
          </button>
        </div>

      </div>
    </div>
  );
}